import React from 'react';
import { SvgIcon } from '@mui/material';
import { iconType } from './icon-types';

const FileIcon = (properties: iconType) => (
  <SvgIcon
    {...properties}
    viewBox="0 0 20 20"
    style={{ fill: 'none', width: '24px', height: '32px'}}
  >
    <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zM6 20V4h7v5h5v11H6z"/>
  </SvgIcon>
);

FileIcon.defaultProperties = {
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export default FileIcon;
